/* eslint-disable import/no-unused-modules */
export const localeCookie = 'sc-language';

export const defaultLocale = 'en-US';
